import { SUPPORT_WIDGET_LOCAL_STORAGE_KEY } from "../constants";

interface FormValues {
  area?: string;
  priority?: string;
  text?: string;
  type?: string;
}

interface StorageData {
  [key: string]: string[] | string | boolean | undefined | FormValues;
  formValues?: FormValues;
}

export const getLocalStorage = (): StorageData | null => {
  try {
    return safeParseJSON(
      localStorage.getItem(SUPPORT_WIDGET_LOCAL_STORAGE_KEY),
    );
  } catch (error) {
    console.error("Failed to get item from localStorage:", error);
    return null;
  }
};

export const setLocalStorage = (values: StorageData): void => {
  try {
    localStorage.setItem(
      SUPPORT_WIDGET_LOCAL_STORAGE_KEY,
      JSON.stringify(values),
    );
  } catch (error) {
    console.error("Failed to set item in localStorage:", error);
  }
};

const safeParseJSON = (key: string | null): StorageData | null => {
  try {
    return key ? JSON.parse(key) : null;
  } catch (e) {
    console.error("Parsing JSON failed", e);
    return null;
  }
};

// Code is copied and simplified from https://github.com/bryanwoods/autolink-js/blob/master/autolink.js
const URL_PATTERN =
  /(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[-A-Z0-9+\u0026\u2019@#/%?=()~_|!:,.;]*[-A-Z0-9+\u0026@#/%=~()_|])/gi;

export const autolink = function (content: string): string {
  try {
    return content.replace(
      URL_PATTERN,
      function (_match: string, space: string, url: string) {
        return `${space}<a class="break-all" href='${url}' target='_blank' rel='noopener noreferrer'>${url}</a>`;
      },
    );
  } catch (error) {
    return content;
  }
};
